<template>
  <div class="achievement-list-wrapper">
    <a-card :bordered="false" class="content">
      <!-- 页面标题 -->
      <div class="page-header">
        <h1 class="page-title">
          <span class="title-text">科技成果</span>
          <span class="title-bg">TECH ACHIEVEMENT</span>
        </h1>
      </div>

      <!-- 搜索区域 -->
      <div class="search-section">
        <div class="search-row">
          <span class="search-label">搜索:</span>
          <a-input
            class="search-input"
            placeholder="请输入搜索关键字"
            v-model="queryParam.name"
            @keyup.enter.native="searchQuery"
          >
            <a-icon slot="prefix" type="search" />
          </a-input>
          <a-button type="primary" icon="search" @click="searchQuery" class="search-btn">
          </a-button>
        </div>
        <div class="search-row">
          <span class="search-label">完成单位:</span>
          <a-input
            class="search-input"
            placeholder="请输入完成单位"
            v-model="queryParam.completionUnit"
            @keyup.enter.native="searchQuery"
          >
            <a-icon slot="prefix" type="search" />
          </a-input>
          <a-button type="primary" icon="search" @click="searchQuery" class="search-btn">
          </a-button>
        </div>
      </div>

      <!-- 筛选区域 -->
      <div class="filter-section">
        <div class="filter-row">
          <span class="filter-label">所属领域:</span>
          <div class="filter-tags">
            <a-tag
              :class="{ 'tag-active': !queryParam.technicalField }"
              @click="handleFilterChange('technicalField', '')"
              class="filter-tag"
            >
              全部
            </a-tag>
            <a-tag
              v-for="item in fieldOptions"
              :key="item.value"
              :class="{ 'tag-active': queryParam.technicalField === item.value }"
              @click="handleFilterChange('technicalField', item.value)"
              class="filter-tag"
            >
              {{ item.text }}
            </a-tag>
          </div>
        </div>
        <!-- <div class="filter-row">
          <span class="filter-label">按技术成熟度:</span>
          <div class="filter-tags">
            <a-tag
              :class="{ 'tag-active': !queryParam.technicalMaturity }"
              @click="handleFilterChange('technicalMaturity', '')"
              class="filter-tag"
            >
              全部
            </a-tag>
            <a-tag
              v-for="item in maturityOptions"
              :key="item.value"
              :class="{ 'tag-active': queryParam.technicalMaturity === item.value }"
              @click="handleFilterChange('technicalMaturity', item.value)"
              class="filter-tag"
            >
              {{ item.text }}
            </a-tag>
          </div>
        </div>
        <div class="filter-row">
          <span class="filter-label">按合作方式:</span>
          <div class="filter-tags">
            <a-tag
              :class="{ 'tag-active': !queryParam.cooperateWay }"
              @click="handleFilterChange('cooperateWay', '')"
              class="filter-tag"
            >
              全部
            </a-tag>
            <a-tag
              v-for="item in cooperateOptions"
              :key="item.value"
              :class="{ 'tag-active': queryParam.cooperateWay === item.value }"
              @click="handleFilterChange('cooperateWay', item.value)"
              class="filter-tag"
            >
              {{ item.text }}
            </a-tag>
          </div>
        </div> -->
        <div class="filter-row">
          <span class="filter-label">所在地区:</span>
          <div class="filter-tags">
            <a-tag
              :class="{ 'tag-active': !queryParam.areaId }"
              @click="handleFilterChange('areaId', '')"
              class="filter-tag"
            >
              全部
            </a-tag>
            <a-tag
              v-for="item in regionOptions"
              :key="item.value"
              :class="{ 'tag-active': queryParam.areaId === item.value }"
              @click="handleFilterChange('areaId', item.value)"
              class="filter-tag"
            >
              {{ item.text }}
            </a-tag>
          </div>
        </div>
      </div>

      <!-- 结果统计和排序 -->
      <div class="result-header">
        <div class="result-count">
          共找到<span class="count-number">{{ ipagination.total || 0 }}</span>项成果
        </div>
        <div class="sort-options">
          <span
            :class="['sort-item', { 'sort-active': sortType === 'latest' }]"
            @click="handleSortChange('latest')"
          >
            最新入驻排序
          </span>
          <span
            :class="['sort-item', { 'sort-active': sortType === 'views' }]"
            @click="handleSortChange('views')"
          >
            浏览量排序
          </span>
        </div>
      </div>

      <!-- 卡片列表 -->
      <div class="card-list-wrapper">
        <a-spin :spinning="loading">
        <a-row :gutter="[16, 16]">
          <a-col
            v-for="item in dataSource"
            :key="item.id"
            :xs="24"
            :sm="12"
            :md="12"
            :lg="6"
            :xl="6"
          >
            <div
              class="achievement-card"
              @click="handleDetail(item)"
            >
              <div class="card-image">
                <img
                  :src="getImageUrl(item)"
                  :alt="item.name"
                  @error="handleImageError"
                />
              </div>
              <div class="card-content">
                <h3 class="card-title" :title="item.name">{{ item.name }}</h3>
                <div class="card-info">
                  <div class="info-item">
                    <span class="info-label">所在地区:</span>
                    <span class="info-value">{{ getAreaText(item) || '未填写' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">技术成熟度:</span>
                    <span class="info-value">{{ item.technicalMaturity || '未填写' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">合作方式:</span>
                    <span class="info-value">{{ item.cooperateWay || '未填写' }}</span>
                  </div>
                </div>
              </div>
            </div>
          </a-col>
        </a-row>
        <a-empty v-if="!loading && dataSource.length === 0" description="暂无数据" />
        </a-spin>
      </div>

      <!-- 分页 -->
      <div class="pagination-wrapper">
        <div class="pagination-info">
          <span>共{{ ipagination.total || 0 }}条</span>
        </div>
        <a-pagination
          :current="ipagination.current"
          :total="ipagination.total"
          :pageSize="ipagination.pageSize"
          :showTotal="() => ''"
          showSizeChanger
          :pageSizeOptions="['12', '24', '48']"
          @change="handlePageChange"
          @showSizeChange="handlePageSizeChange"
        />
        <div class="pagination-jump">
          <span>前往</span>
          <a-input-number
            :min="1"
            :max="Math.ceil((ipagination.total || 0) / ipagination.pageSize)"
            :value="ipagination.current"
            @change="handleJumpPage"
            style="width: 60px; margin: 0 4px"
          />
          <span>页</span>
        </div>
      </div>
    </a-card>
  </div>
</template>

<script>
import { getAction } from "@/api/manage";
import { JeecgListMixin } from "@/mixins/JeecgListMixin";
import { ajaxGetDictItems } from "@/api/api";
import { getFileAccessHttpUrl } from '@api/manage'
import Area from '@/components/_util/Area'

export default {
  name: "AchievementList",
  mixins: [JeecgListMixin],
  data() {
    return {
      description: "科技成果列表",
      url: {
        list: "/xjtech/techAchievement/list"
      },
      sortType: "latest", // latest: 最新入驻, views: 浏览量
      fieldOptions: [], // 技术领域选项
      maturityOptions: [], // 技术成熟度选项
      cooperateOptions: [], // 合作方式选项
      regionOptions: [], // 地区选项
      pcaData: null, // 省市区工具
      queryParam: {
        reviewStatus: 1
      }
    };
  },
  mounted() {
    // 设置默认分页大小
    if (this.ipagination) {
      this.ipagination.pageSize = 12;
    }
  },
  created() {
    this.pcaData = new Area()
    this.initDictOptions();
  },
  methods: {
    getFileAccessHttpUrl,
    // 初始化字典选项
    initDictOptions() {
      // 获取技术成熟度选项
      ajaxGetDictItems("technical_maturity").then((res) => {
        if (res.success) {
          this.maturityOptions = res.result || [];
        }
      });
      // 获取合作方式选项
      ajaxGetDictItems("cooperate_way").then((res) => {
        if (res.success) {
          this.cooperateOptions = res.result || [];
        }
      });
      // 获取技术领域选项（从分类树获取）
      this.loadFieldOptions();
      // 获取地区选项
      this.loadRegionOptions();
    },
    // 加载技术领域选项
    loadFieldOptions() {
      getAction("/sys/category/loadTreeData", {
        pcode: "B03"
      }).then((res) => {
        if (res.success && res.result) {
          this.fieldOptions = res.result.map((item) => ({
            value: item.key,
            text: item.title
          }));
        }
      });
    },
    // 加载地区选项（简化版，实际应该从地区字典获取）
    loadRegionOptions() {
      const regions = [
        { value: "110000", text: "北京市" },
        { value: "120000", text: "天津市" },
        { value: "130000", text: "河北省" },
        { value: "140000", text: "山西省" },
        { value: "150000", text: "内蒙古自治区" },
        { value: "210000", text: "辽宁省" },
        { value: "220000", text: "吉林省" },
        { value: "230000", text: "黑龙江省" },
        { value: "310000", text: "上海市" },
        { value: "320000", text: "江苏省" },
        { value: "330000", text: "浙江省" },
        { value: "340000", text: "安徽省" },
        { value: "350000", text: "福建省" },
        { value: "360000", text: "江西省" },
        { value: "370000", text: "山东省" },
        { value: "410000", text: "河南省" },
        { value: "420000", text: "湖北省" },
        { value: "430000", text: "湖南省" },
        { value: "440000", text: "广东省" },
        { value: "450000", text: "广西壮族自治区" },
        { value: "460000", text: "海南省" },
        { value: "500000", text: "重庆市" },
        { value: "510000", text: "四川省" },
        { value: "520000", text: "贵州省" },
        { value: "530000", text: "云南省" },
        { value: "540000", text: "西藏自治区" },
        { value: "610000", text: "陕西省" },
        { value: "620000", text: "甘肃省" },
        { value: "630000", text: "青海省" },
        { value: "640000", text: "宁夏回族自治区" },
        { value: "650000", text: "新疆维吾尔自治区" },
        { value: "660000", text: "新疆生产建设兵团" }
      ];
      this.regionOptions = regions;
    },
    // 筛选标签点击
    handleFilterChange(field, value) {
      this.queryParam[field] = value;
      this.searchQuery();
    },
    // 排序切换
    handleSortChange(type) {
      this.sortType = type;
      if (type === "latest") {
        this.isorter.column = "createTime";
        this.isorter.order = "desc";
      } else if (type === "views") {
        this.isorter.column = "viewCount";
        this.isorter.order = "desc";
      }
      this.searchQuery();
    },
    // 分页改变
    handlePageChange(page, pageSize) {
      this.ipagination.current = page;
      this.ipagination.pageSize = pageSize;
      this.loadData();
    },
    // 每页条数改变
    handlePageSizeChange(current, size) {
      this.ipagination.current = 1;
      this.ipagination.pageSize = size;
      this.loadData();
    },
    // 跳转页面
    handleJumpPage(page) {
      if (page && page > 0) {
        const maxPage = Math.ceil((this.ipagination.total || 0) / this.ipagination.pageSize);
        if (page > maxPage) {
          this.$message.warning(`最大页数为${maxPage}`);
          return;
        }
        this.ipagination.current = page;
        this.loadData();
      }
    },
    // 获取图片URL
    getImageUrl(item) {
      // 尝试多种可能的图片字段
      const imageFields = ['imageUrl', 'cover', 'image', 'picture', 'coverUrl', 'picUrl'];
      for (const field of imageFields) {
        if (item[field]) {
          // 如果是相对路径，可能需要添加基础URL
          return item[field].startsWith('http') ? item[field] : this.getFileAccessHttpUrl(item[field]);
        }
      }
      // 默认占位图
      return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='200'%3E%3Crect fill='%23f0f0f0' width='300' height='200'/%3E%3Ctext x='50%25' y='50%25' text-anchor='middle' dy='.3em' fill='%23999' font-size='14'%3E暂无图片%3C/text%3E%3C/svg%3E";
    },
    // 图片加载错误处理
    handleImageError(e) {
      e.target.src =
        "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='200'%3E%3Crect fill='%23f0f0f0' width='300' height='200'/%3E%3Ctext x='50%25' y='50%25' text-anchor='middle' dy='.3em' fill='%23999' font-size='14'%3E暂无图片%3C/text%3E%3C/svg%3E";
    },
    // 查看详情
    handleDetail(record) {
      this.$router.push({
        path: "/achievement/detail",
        query: { id: record.id }
      });
    },
    // 获取地区文本
    getAreaText(item) {
      if (!item) return ''
      // 优先使用字典文本，如果没有则通过 Area.js 获取
      return item.areaId_dictText || (item.areaId && this.pcaData ? this.pcaData.getText(item.areaId) : '') || ''
    }
  }
};
</script>

<style scoped lang="less">
.achievement-list-wrapper {
  background: #f0f2f5;
  min-height: 100vh;
  //padding: 12px;
  animation: fadeIn 0.5s ease-in-out;

  .content {
    background: #fff;
    border-radius: 8px;
    padding: 32px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    transition: box-shadow 0.3s ease;
    
    &:hover {
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    }
  }
}

// 页面标题
.page-header {
  margin-bottom: 32px;
  text-align: center;
  position: relative;
  padding: 20px 0;

  .page-title {
    position: relative;
    display: inline-block;
    margin: 0;
    padding: 0;

    .title-text {
      font-size: 36px;
      font-weight: 600;
      color: #333;
      position: relative;
      z-index: 2;
      letter-spacing: 2px;
      animation: slideDown 0.6s ease-out;
    }

    .title-bg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 72px;
      font-weight: 300;
      color: rgba(0, 0, 0, 0.03);
      z-index: 1;
      letter-spacing: 8px;
      white-space: nowrap;
      animation: fadeInScale 0.8s ease-out;
    }
  }
}

// 动画定义
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.8);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes countUp {
  from {
    opacity: 0;
    transform: scale(0.5);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

// 搜索区域
.search-section {
  margin-bottom: 32px;
  animation: slideInLeft 0.6s ease-out 0.2s both;

  .search-row {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    transition: all 0.3s ease;

    &:hover {
      transform: translateX(4px);
    }

    .search-label {
      width: 80px;
      font-size: 14px;
      color: #333;
      flex-shrink: 0;
      font-weight: 500;
    }

    .search-input {
      flex: 1;
      max-width: 500px;
      margin-right: 12px;
      transition: all 0.3s ease;
      border-radius: 4px;

      &:focus,
      &:hover {
        border-color: #1890ff;
        box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);
      }

      /deep/ .ant-input {
        transition: all 0.3s ease;
      }
    }

    .search-btn {
      min-width: 48px;
      height: 32px;
      padding: 0 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      transition: all 0.3s ease;
      box-shadow: 0 2px 4px rgba(24, 144, 255, 0.2);

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(24, 144, 255, 0.3);
      }

      &:active {
        transform: translateY(0);
      }

      /deep/ .anticon {
        font-size: 16px;
      }
    }
  }
}

// 筛选区域
.filter-section {
  margin-bottom: 32px;
  padding: 24px;
  background: #fafafa;
  border-radius: 8px;
  border: 1px solid #e8e8e8;
  animation: slideInLeft 0.6s ease-out 0.3s both;

  .filter-row {
    display: flex;
    align-items: flex-start;
    margin-bottom: 20px;
    transition: all 0.3s ease;

    &:last-child {
      margin-bottom: 0;
    }

    .filter-label {
      width: 100px;
      font-size: 14px;
      color: #333;
      flex-shrink: 0;
      padding-top: 6px;
      font-weight: 500;
    }

    .filter-tags {
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      gap: 10px;

      .filter-tag {
        margin: 0;
        padding: 6px 16px;
        cursor: pointer;
        border: 1px solid #d9d9d9;
        background: #fff;
        color: #333;
        border-radius: 20px;
        font-size: 14px;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        position: relative;
        overflow: hidden;

        &::before {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          width: 0;
          height: 0;
          border-radius: 50%;
          background: rgba(24, 144, 255, 0.1);
          transform: translate(-50%, -50%);
          transition: width 0.4s ease, height 0.4s ease;
        }

        &:hover {
          border-color: #1890ff;
          color: #1890ff;
          transform: translateY(-2px);
          box-shadow: 0 2px 8px rgba(24, 144, 255, 0.2);

          &::before {
            width: 100px;
            height: 100px;
          }
        }

        &.tag-active {
          background: #1890ff;
          border-color: #1890ff;
          color: #fff;
          font-weight: 500;
          box-shadow: 0 2px 8px rgba(24, 144, 255, 0.3);
          animation: pulse 0.3s ease;

          &:hover {
            background: #40a9ff;
            border-color: #40a9ff;
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(24, 144, 255, 0.4);
          }

          &::before {
            background: rgba(255, 255, 255, 0.2);
          }
        }
      }
    }
  }
}

// 结果头部
.result-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 16px 0;
  border-bottom: 2px solid #e8e8e8;
  animation: slideInLeft 0.6s ease-out 0.4s both;

  .result-count {
    font-size: 15px;
    color: #333;
    font-weight: 500;

    .count-number {
      color: #ff6600;
      font-weight: 700;
      font-size: 18px;
      margin: 0 6px;
      animation: countUp 0.6s ease-out;
    }
  }

  .sort-options {
    display: flex;
    gap: 20px;

    .sort-item {
      font-size: 14px;
      color: #666;
      cursor: pointer;
      padding: 6px 16px;
      border-radius: 20px;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      position: relative;
      font-weight: 500;

      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 50%;
        width: 0;
        height: 2px;
        background: #1890ff;
        transform: translateX(-50%);
        transition: width 0.3s ease;
      }

      &:hover {
        color: #1890ff;
        background: #e6f7ff;
        transform: translateY(-2px);

        &::after {
          width: 60%;
        }
      }

      &.sort-active {
        color: #1890ff;
        background: #e6f7ff;
        font-weight: 600;
        box-shadow: 0 2px 4px rgba(24, 144, 255, 0.2);

        &::after {
          width: 80%;
        }
      }
    }
  }
}

// 卡片列表
.card-list-wrapper {
  min-height: 400px;
  margin-bottom: 24px;
  animation: slideInLeft 0.6s ease-out 0.5s both;
}

.achievement-card {
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  animation: fadeInUp 0.6s ease-out;
  animation-fill-mode: both;

  &:nth-child(1) { animation-delay: 0.1s; }
  &:nth-child(2) { animation-delay: 0.15s; }
  &:nth-child(3) { animation-delay: 0.2s; }
  &:nth-child(4) { animation-delay: 0.25s; }
  &:nth-child(5) { animation-delay: 0.3s; }
  &:nth-child(6) { animation-delay: 0.35s; }
  &:nth-child(7) { animation-delay: 0.4s; }
  &:nth-child(8) { animation-delay: 0.45s; }
  &:nth-child(9) { animation-delay: 0.5s; }
  &:nth-child(10) { animation-delay: 0.55s; }
  &:nth-child(11) { animation-delay: 0.6s; }
  &:nth-child(12) { animation-delay: 0.65s; }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(24, 144, 255, 0.05) 0%, rgba(24, 144, 255, 0) 100%);
    opacity: 0;
    transition: opacity 0.4s ease;
    z-index: 1;
    pointer-events: none;
  }

  &:hover {
    box-shadow: 0 8px 24px rgba(24, 144, 255, 0.2);
    transform: translateY(-8px) scale(1.02);
    border-color: #1890ff;

    &::before {
      opacity: 1;
    }

    .card-image img {
      transform: scale(1.1);
    }

    .card-title {
      color: #1890ff;
    }
  }

  .card-image {
    width: 100%;
    height: 180px;
    overflow: hidden;
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.02);
      transition: background 0.3s ease;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
    }

    &:hover::after {
      background: rgba(0, 0, 0, 0);
    }
  }

  .card-content {
    padding: 20px;
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 2;

    .card-title {
      font-size: 16px;
      font-weight: 600;
      color: #333;
      margin: 0 0 16px 0;
      line-height: 1.5;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      min-height: 48px;
      transition: all 0.3s ease;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        bottom: -4px;
        left: 0;
        width: 0;
        height: 2px;
        background: #1890ff;
        transition: width 0.3s ease;
      }

      &:hover::after {
        width: 100%;
      }
    }

    .card-info {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 10px;

      .info-item {
        display: flex;
        align-items: center;
        font-size: 13px;
        line-height: 1.6;
        transition: all 0.3s ease;
        padding: 4px 0;

        &:hover {
          transform: translateX(4px);
        }

        .info-label {
          color: #666;
          margin-right: 6px;
          flex-shrink: 0;
          font-weight: 500;
        }

        .info-value {
          color: #333;
          flex: 1;
          word-break: break-all;
          transition: color 0.3s ease;

          &:hover {
            color: #1890ff;
          }
        }
      }
    }
  }
}

// 分页区域
.pagination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  border-top: 2px solid #e8e8e8;
  animation: slideInLeft 0.6s ease-out 0.6s both;

  .pagination-info {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #666;
    font-weight: 500;
  }

  .pagination-jump {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #666;
    gap: 4px;

    /deep/ .ant-input-number {
      transition: all 0.3s ease;

      &:hover,
      &:focus {
        border-color: #1890ff;
        box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);
      }
    }
  }

  /deep/ .ant-pagination {
    .ant-pagination-item {
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      }

      &.ant-pagination-item-active {
        box-shadow: 0 2px 8px rgba(24, 144, 255, 0.3);
      }
    }

    .ant-pagination-prev,
    .ant-pagination-next {
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-2px);
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .achievement-list-wrapper {
    padding: 8px;

    .content {
      padding: 16px;
    }
  }

  .page-header {
    margin-bottom: 24px;
    padding: 16px 0;

    .page-title {
      .title-text {
        font-size: 28px;
      }

      .title-bg {
        font-size: 48px;
      }
    }
  }

  .search-section {
    margin-bottom: 24px;

    .search-row {
      flex-direction: column;
      align-items: flex-start;

      .search-label {
        margin-bottom: 8px;
      }

      .search-input {
        max-width: 100%;
        width: 100%;
        margin-right: 0;
        margin-bottom: 8px;
      }
    }
  }

  .filter-section {
    padding: 16px;

    .filter-row {
      flex-direction: column;

      .filter-label {
        margin-bottom: 12px;
        width: 100%;
      }
    }
  }

  .result-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .achievement-card {
    &:hover {
      transform: translateY(-4px) scale(1);
    }
  }

  .pagination-wrapper {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }
}
</style>